/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_GreetingInputs */

const en_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const th_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดีค่ะ ยินดีช่วยเลือกสายพันธุ์และตอบคำถามเรื่องการปลูก บอกได้เลยว่ากำลังมองหาแบบไหน และปลูกในร่มหรือกลางแจ้ง`)
};

const ja_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const fr_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const es_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const ru_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const zh_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors.`)
};

const vi_chat_greeting = /** @type {(inputs: Chat_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào. Tôi có thể giúp bạn chọn giống hoặc trả lời câu hỏi về cách trồng — hãy cho tôi biết bạn đang tìm gì, và bạn trồng trong nhà hay ngoài trời.`)
};

/**
* | output |
* | --- |
* | "Hello. I can help you pick a strain or answer growing questions — tell me what you are after, and whether you are growing indoors or outdoors." |
*
* @param {Chat_GreetingInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_greeting = /** @type {((inputs?: Chat_GreetingInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_GreetingInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_greeting(inputs)
	if (locale === "ja") return ja_chat_greeting(inputs)
	if (locale === "fr") return fr_chat_greeting(inputs)
	if (locale === "es") return es_chat_greeting(inputs)
	if (locale === "ru") return ru_chat_greeting(inputs)
	if (locale === "zh") return zh_chat_greeting(inputs)
	if (locale === "vi") return vi_chat_greeting(inputs)
	return en_chat_greeting(inputs)
});